import React from 'react';

const NoRoute = () => {
    return (
        <div>
            <div className="container text-center py-5">
                <img style={{'maxWidth':'600px', 'width':'100%'}} src="images/404.png" alt="" />
            </div>
        </div>
    );
};

export default NoRoute;